"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAreFilesBeingReplaced = exports.getVideoPlayerRequestStatus = exports.getFetchFilesTimestamp = exports.getIsSearching = exports.getFetchFilesRequestStatus = exports.getFilesTotal = exports.getFiles = void 0;

var _reselect = require("reselect");

var _file = require("../utils/file");

var getFiles = function getFiles(state) {
  return state.files.get('objects');
};

exports.getFiles = getFiles;

var getFilesTotal = function getFilesTotal(state) {
  return state.files.get('total');
};

exports.getFilesTotal = getFilesTotal;

var getFetchFilesRequestStatus = function getFetchFilesRequestStatus(state) {
  return state.files.get('status');
};

exports.getFetchFilesRequestStatus = getFetchFilesRequestStatus;

var getFilesQuery = function getFilesQuery(state) {
  return state.files.get('query');
};

var getIsSearching = (0, _reselect.createSelector)([getFilesQuery], function (query) {
  return Boolean(query.get('search'));
});
exports.getIsSearching = getIsSearching;

var getFetchFilesTimestamp = function getFetchFilesTimestamp(state) {
  return state.files.get('timestamp');
};

exports.getFetchFilesTimestamp = getFetchFilesTimestamp;

var getVideoPlayerRequestStatus = function getVideoPlayerRequestStatus(state) {
  return state.files.get('videoPlayerRequestStatus');
};

exports.getVideoPlayerRequestStatus = getVideoPlayerRequestStatus;
var getAreFilesBeingReplaced = (0, _reselect.createSelector)([getFiles], function (files) {
  return files.some(_file.getIsFileBeingReplaced);
});
exports.getAreFilesBeingReplaced = getAreFilesBeingReplaced;